import Breadcrumb from './Breadcrumb';

export default {
  install(Vue) {
    Vue.component('BreadCrumb', Breadcrumb);
  },
};
